angular.
module("dx.webapp.routes", [
	"digiexam.exam",
	"digiexam.services",
	"dx.webapp.api",
	"dx.webapp.exam",
	"dx.webapp.exams",
	"dx.webapp.logging",
	"dx.webapp.masterTools.studentMerge",
	"dx.webapp.navigation",
	"dx.webapp.roles",

	"dx.ui.components.dialog",
	"dx.ui.components.localize",
]);
